import React, { useState, useEffect } from 'react';
import { Auth, FormSelect } from '../Form/Form';
import { PDFDownloadLink, Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import Spinner from '../0components/Spinner';
import Button from '../0components/Button';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export default _ => {
    const [isVisible, setIsVisible] = useState(false);

    return (<div className="d-flex justify-content-between align-items-center" onClick={_ => setIsVisible(true)}>
        <p className="my-auto"><span className="badge badge-danger mr-3">PDF</span>Statistiques Par Province</p>
        <button className="btn btn-primary ml-3" >
            <i className="fas fa-sm fa-arrow-down" data-toggle="tooltip" title="Télécharger" />
        </button>
        {isVisible && <MyModal isVisible={isVisible} setIsVisible={setIsVisible} />}
    </div>);
}

const MyModal = ({ isVisible, setIsVisible }) => {
    const [step, setStep] = useState(0); // 0: init, 1: Loading, 2:Ready

    const currentYear = new Date().getFullYear();
    const beginYear = 1979; //pour le modal
    const endYear = currentYear + 1; //pour le modal
    const [annee, setAnnee] = useState(new Date().getFullYear()); //année de recherche
    const [annees, setAnnees] = useState([]); //liste des années

    const [province, setProvince] = useState();

    const [data, setData] = useState([]); //données des membres

    useEffect(_ => setAnnees(yearsListBetween(beginYear, endYear)), [beginYear, endYear]);
    useEffect(_ => fetchData(annee, province), [annee, province, isVisible]);

    const yearsListBetween = (debut, fin) => {
        let tmp = []
        for (let i = fin; i >= debut; i--)
            tmp.push(i);
        return tmp;
    }

    const fetchData = (annee, province) => {
        setStep(1);
        if (annee && province) {
            Auth.fetch(`/api/stats/cmp?annee=${annee}&province=${province}`, Auth.options('GET'))
                .then(res => setData(res))
                .then(_ => setStep(2))
                .catch(err => console.error(err))
        } else
            setStep(0);
    }

    const renderBotom = step => {
        switch (step) {
            case 1:
                return <Spinner />;
            case 2:
                return (<PDFDownloadLink document={<Layout data={data} annee={annee}></Layout>} fileName={`FFBMP Répartition des membres ${annee}.pdf`}>
                    {({ loading }) => (loading ? 'Génération du document...' : <Button icon="fa-download" onClick={_ => setIsVisible(false)}>Télécharger</Button>)}
                </PDFDownloadLink>);
            default:
                return (<></>);
        }
    }

    return (<Modal isOpen={isVisible} toggle={_ => setIsVisible(!isVisible)}>
        <ModalHeader >PDF - Statistiques Par Province</ModalHeader>
        <ModalBody>
            <FormSelect label="Année" required value={annee} handleChange={val => setAnnee(val)} disabled={step === 1}>
                {annees.map(e => <option value={e} key={e}>{e}</option>)}
            </FormSelect>
            <FormSelect label="Province" required value={province} handleChange={val => setProvince(val)} disabled={step === 1}>
                <option value="">Sélectionner une province</option>
                <option value="dfc8be92-8cb2-11de-a173-001372568c9a">BRUXELLES - BRABANT WALLON</option>
                <option value="dfc8c0fe-8cb2-11de-a173-001372568c9a">HAINAUT</option>
                <option value="dfc8c284-8cb2-11de-a173-001372568c9a">LIEGE</option>
                <option value="dfc8c3f6-8cb2-11de-a173-001372568c9a">LUXEMBOIURG</option>
                <option value="dfc8c554-8cb2-11de-a173-001372568c9a">NAMUR</option>
            </FormSelect>
            {renderBotom(step)}
        </ModalBody>
    </Modal>);
}

const Layout = ({ data, annee }) => {

    const reducer = (previousValue, currentValue) => previousValue + currentValue;

    const styles = StyleSheet.create({
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35
        },
        row: { flexDirection: "row" },
        pageFooter: {
            position: 'absolute',
            fontSize: 8,
            bottom: 8,
            left: 10,
            right: 10,
            color: 'grey'
        },
        pageFooterCenter: { textAlign: 'center' },
        pageFooterLeft: { textAlign: 'left' },
        pageFooterRight: { textAlign: 'right' },
        table: {
            display: "table",
            width: "auto",
            borderStyle: "solid",
            borderColor: '#000',
            borderWidth: 1,
            borderRightWidth: 0,
            borderBottomWidth: 0
        },
        tableRow: {
            margin: "auto",
            flexDirection: "row"
        },
        tableCol: {
            textAlign: "center",
            borderStyle: "solid",
            borderColor: '#000',
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            padding: 2
        },
        tableCollHeader: {
            fontSize: 12,
            fontWeight: 500
        },
        tableCell: { fontSize: 7 },
        tableCellSmall: { fontSize: 6 }
    });

    return (<Document>
        <Page style={styles.body} orientation="landscape">
            <Text style={[styles.subtitle, { fontSize: 20, marginBottom: 10 }]}>FEDERATION FRANCOPHONE BELGE DE MARCHES POPULAIRES </Text>

            {data && data.length > 0 ? <>
                <Text style={[styles.subtitle, { fontSize: 15, marginBottom: 10 }]}>{data[0].nom} - Année {annee}</Text>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "25%" }]}>
                            <Text style={styles.tableCell}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "25%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>Adresse du Siège</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>Nombre de Membres</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "25%" }]}>
                            <Text style={styles.tableCell}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "25%" }]}>
                            <Text style={styles.tableCell}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>- 6 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>- 12 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>- 18 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>- 25 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>- 35 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "6%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>+ 35 ans</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "14%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>TOTAUX</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "25%" }]}>
                            <Text style={styles.tableCell}>Nom du Cercle</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%" }]}>
                            <Text style={styles.tableCell}>Adresse</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={styles.tableCell}>CP</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%" }]}>
                            <Text style={styles.tableCell}>Localite</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>F</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>H</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>A</Text>
                        </View>

                        <View style={[styles.tableCol, { width: "8%", textAlign: 'center' }]}>
                            <Text style={styles.tableCell}>TOTAL</Text>
                        </View>
                    </View>

                    {data.map(e => <View key={e.club} style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "25%" }]}>
                            <Text style={styles.tableCell}>{e.club}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "12%" }]}>
                            <Text style={styles.tableCell}>{e.adresse}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={styles.tableCell}>{e.cp}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%" }]}>
                            <Text style={styles.tableCell}>{e.localite}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.f6}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.m6}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.a6}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.f12}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.m12}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.a12}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.f18}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.m18}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.a18}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.f25}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.m25}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.a25}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.f35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.m35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.a35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.fP35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.mP35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.aP35}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.totF}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.totM}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{e.totA}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "8%" }]}>
                            <Text style={styles.tableCellSmall}>{e.tot}</Text>
                        </View>
                    </View>)}

                    {data ? <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "50%" }]}>
                            <Text style={styles.tableCellSmall}>- TOTAL -</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.f6).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.m6).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.a6).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.f12).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.m12).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.a12).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.f18).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.m18).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.a18).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.f25).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.m25).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.a25).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.f35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.m35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.a35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.fP35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.mP35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.aP35).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.totF).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.totM).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "2%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.totA).reduce(reducer)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "8%" }]}>
                            <Text style={styles.tableCellSmall}>{data.map(e => e.tot).reduce(reducer)}</Text>
                        </View>
                    </View> : ""}
                </View>
            </> : <Text style={[styles.subtitle, { fontSize: 15, marginBottom: 10 }]} > Aucune données </Text>}
            <Text style={[styles.pageFooter, styles.pageFooterLeft]} render={({ pageNumber, totalPages }) => (`FFBMP ${pageNumber} / ${totalPages}`)} fixed />
            <Text style={[styles.pageFooter, styles.pageFooterCenter]} fixed >Année {annee}</Text>
            <Text style={[styles.pageFooter, styles.pageFooterRight]} fixed >Date: {new Date().toLocaleDateString()}</Text>
        </Page>
    </Document>);
}